import { Route, Routes } from 'react-router-dom';
import { ListAgency } from './components/ListAgency';
import { FormAgency } from './components/FormAgency';
import { InfluencersAgency } from './components/InfluencersAgency';
import { ListPendingEmails } from './components/ListPendingEmails';
import { AgencyManagers } from './components/AgencyManagers';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';
import { PendingInfluencers } from './components/PendingInfluencers';

export function AgencyRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.AGENCY) && (
                <>
                    <Route path="overview" element={<ListAgency />} />
                    <Route path="edit/:agencyId" element={<FormAgency />} />
                    <Route path="create" element={<FormAgency />} />
                    <Route path="influencers/:id" element={<InfluencersAgency />} />
                    <Route path="managers/:id" element={<AgencyManagers />} />
                    <Route path="pending-emails/:agencyId" element={<ListPendingEmails />} />
                    <Route path="requested-influencers" element={<PendingInfluencers />} />
                </>
            )}
        </Routes>
    );
}
